import React, { useEffect } from 'react';
import './App.scss';
import AppRoutes from './routes/AppRoutes';
import { createTheme, ThemeProvider } from '@mui/material';
import theme from './theme';
import ChargebeeService from './services/chargebee.service';
import { ToastContainer } from 'react-toastify';
import { config } from './config';

declare global {
  interface Window {
    Chargebee?: any;
  }
}
console.log('---------------------------------------',config.auth_api_url);
const App: React.FC = () => {
  useEffect(() => {
    // Make sure to wait for the script to load
    const initChargebee = () => {
      if (window.Chargebee) {
        ChargebeeService.initChargebee(config.chargebee_site); 
      } else {
        // Retry after a short delay if Chargebee isn't loaded yet
        setTimeout(initChargebee, 100);
      }
    };

    initChargebee();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <AppRoutes />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className="custom-toast-style"
      />
    </ThemeProvider>
  );
};

export default App;
